import PMList from "@/components/PMs/PMList.vue";
import PMEdit from "@/components/PMs/PMEdit.vue";
import PMHeader from "@/components/PMs/PMHeader.vue";

export default [
    {
        path: 'pm',
        alias: 'pms',
        name: 'All PMs',
        redirect: "/pm/list",
        components: {
            page: PMList,
            header: PMHeader,
        },
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "list/:filter?",
                name: "PM List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "new",
                name: "PM New",
                components: {
                    modal: PMEdit,
                }
            },
            {
                path: "edit/:id",
                name: "PM Edit",
                components: {
                    modal: PMEdit,
                }
            }
        ]
    }
];
